/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import * as types from './actionTypes';

// upgrade modal
export const showUpgradeModal = (
  planName?,
  featureName = 'any',
  noTrial = false,
  upgradeTo = null
) => ({
  type: types.SHOW_MODAL,
  featureName,
  planName,
  noTrial,
  upgradeTo
});

export const closeUpgradeModal = () => ({
  type: types.CLOSE_MODAL
});

// upgrade plan name
export const upgradePlanStart = (region, instance, upgradingPlanName) => ({
  type: types.UPGRADE_PLAN_START,
  region,
  instance,
  upgradingPlanName
});

export const upgradePlanSuccess = upgradingPlanName => ({
  type: types.UPGRADE_PLAN_SUCCESS,
  upgradingPlanName
});

export const upgradePlanError = error => ({
  type: types.UPGRADE_PLAN_ERROR,
  error
});

// get account type to validate upgrade options
export const getAccountType = accountId => ({
  type: types.GET_ACCOUNT_TYPE,
  accountId
});

export const accountTypeSuccess = accountType => ({
  type: types.ACCOUNT_TYPE_SUCCESS,
  accountType
});

export const accountTypeError = error => ({
  type: types.ACCOUNT_TYPE_ERROR,
  error
});

// get instance usage for the account
export const loadApiUsage = accountId => ({
  type: types.LOAD_API_USAGE,
  accountId
});

export const apiUsageSuccess = count => ({
  type: types.API_USAGE_SUCCESS,
  count
});
